<script setup lang="ts">
import DraggableList from '@/components/DesignStudio/DraggableList.vue';
import CrosswordStyleListItem from './item/CrosswordStyleListItem.vue';
import type { CrosswordStyle } from '../../types';

defineProps<{
    items: CrosswordStyle[];
    disabled?: boolean;
    selectedId?: number;
}>();

const emit = defineEmits<{
    (event: 'select', value: CrosswordStyle): void;
    (event: 'edit', value: CrosswordStyle): void;
    (event: 'remove', value: CrosswordStyle): void;
    (event: 'reorder', value: CrosswordStyle[]): void;
}>();

const onRowClick = (style: CrosswordStyle) => {
    emit('select', style);
};
</script>

<template>
    <draggable-list
        :value="items"
        item-key="id"
        hide-counter
        :draggable="!disabled"
        :selected="selectedId"
        @input="emit('reorder', $event)"
        @row-click="onRowClick"
    >
        <template #item="{ element, selected }">
            <crossword-style-list-item
                :item="element"
                :disabled="disabled"
                :selected="selected"
                @edit="emit('edit', $event)"
                @remove="emit('remove', $event)"
            />
        </template>
    </draggable-list>
</template>
